import Accounts from "../../components/Tables/Accounts/Accounts";

const AccountsPage = () => {
    return <Accounts />;
};

export default AccountsPage;
